// extracted by mini-css-extract-plugin
export const carouselButton = "latest-investments-module--carouselButton--2Bqrz";
export const carouselButtonLeft = "latest-investments-module--carouselButtonLeft--xb4U-";
export const carouselButtonRight = "latest-investments-module--carouselButtonRight--3UKeW";